const MAP = {
  pending_activation: { bg: "bg-gray-100 text-gray-700 border-gray-200",       label: "Pending Activation" },
  invitation_sent:    { bg: "bg-amber-100 text-amber-800 border-amber-200",     label: "Invitation Sent" },
  active_account:     { bg: "bg-emerald-100 text-emerald-800 border-emerald-200", label: "Active Account" },
  expired:            { bg: "bg-rose-100 text-rose-800 border-rose-200",         label: "Invite Expired" },
};

export default function InvitationStatusBadge({ customer }) {
  if (!customer) return null;
  // Derive: if user has a password_hash (activated), prefer active_account
  // even when the user-doc field hasn't migrated.
  let key = customer.invitation_status;
  if (!key) {
    if (!customer.crm_only && !customer.is_admin) key = "active_account";
    else key = "pending_activation";
  }
  const pill = MAP[key] || MAP.pending_activation;
  return (
    <span
      className={`text-[10px] uppercase font-extrabold tracking-wider px-2 py-0.5 rounded-full border ${pill.bg}`}
      data-testid={`inv-badge-${customer.user_id}`}
    >
      {pill.label}
    </span>
  );
}
